import cx from "classnames";
import styles from "./Rating.module.css";

interface Props {
  value: number;
  color?: string;
  size?: "normal" | "small" | "smaller";
}

export default function Rating({ value, size = "normal", color }: Props) {
  const stars = new Array(value).fill(1);
  const className = cx({
    Rating: true,
    RatingSmall: size === "small",
    RatingSmaller: size === "smaller",
  });

  return (
    <span className={styles[className]}>
      {stars.map((_, index) => (
        <span
          key={index}
          style={{ color }}
          dangerouslySetInnerHTML={{
            __html: "&starf;",
          }}
        />
      ))}
    </span>
  );
}
